import { GameState } from './types';
import { WORLD_W, WORLD_H } from './constants';

export function updateCamera(state: GameState, canvasW: number, canvasH: number): void {
  // Target: center on player
  let tx = state.player.x - canvasW / 2;
  let ty = state.player.y - canvasH / 2;

  // Clamp to world bounds
  tx = Math.max(0, Math.min(tx, WORLD_W - canvasW));
  ty = Math.max(0, Math.min(ty, WORLD_H - canvasH));

  // If world smaller than canvas, center it
  if (WORLD_W <= canvasW) tx = (WORLD_W - canvasW) / 2;
  if (WORLD_H <= canvasH) ty = (WORLD_H - canvasH) / 2;

  state.camX = tx;
  state.camY = ty;
}
